module.exports = __webpack_public_path__ + "img/6-1.03d055b9.png";